import Vue from 'vue'


import XMap from './components/XMap.vue'
Vue.component(XMap.name, XMap)

